import 'pixi-sound';
import EventEmitter from 'eventemitter3';
import EventHub from '@/app/game/handlers/EventHub';

import World from '@/app/game/World';

export default class JingleBalls extends EventEmitter
{
    constructor( settings )
    {
        super();

        PIXI.utils.skipHello();
        PIXI.utils.clearTextureCache();

        this.view = settings.view;
        this.version2 = settings.version2;
        this.app = new PIXI.Application( 500, 500, { autoStart: true, view: this.view, transparent: true, legacy: settings.legacy });

        this.eventHub = EventHub;

        if( !PIXI.loader.resources.ball1 )
        {
            for( let i = 1; i < 46; i++ )
            {
                PIXI.loader.add( 'ball' + i, '/static/img/game/tinyballs/' + i + '.png' );
            }

            PIXI.loader.add( 'elem1', '/static/img/game/elem1.png' );
            PIXI.loader.add( 'elem2', '/static/img/game/elem2.png' );
            PIXI.loader.add( 'elem3', '/static/img/game/elem3.png' );
            PIXI.loader.add( 'elem4', '/static/img/game/elem4.png' );
            PIXI.loader.add( 'elem5', '/static/img/game/elem5.png' );
            PIXI.loader.add( 'ornament', '/static/img/game/ornament.png' );
            PIXI.loader.add( 'ornament-broken', '/static/img/game/ornament-broken.png' );
            PIXI.loader.add( 'snowball', '/static/img/game/snowball.png' );

            PIXI.loader.add( 'sound-cadeautje', '/static/sounds/cadeautjes.mp3' );
            PIXI.loader.add( 'sound-kerstbal', '/static/sounds/explosion.mp3' );
            PIXI.loader.add( 'sound-sneeuwbal', '/static/sounds/ignite.mp3' );

            PIXI.loader.add( 'prize0', '/static/img/game/prize0.png' );
            PIXI.loader.add( 'prize1', '/static/img/game/prize1.png' );
            PIXI.loader.add( 'prize2', '/static/img/game/prize2.png' );
            PIXI.loader.add( 'prize3', '/static/img/game/prize3.png' );
            PIXI.loader.add( 'prize4', '/static/img/game/prize4.png' );

            PIXI.loader.load( this.startApp.bind( this ) );
        }
        else
        {
            this.startApp();
        }
    }

    startApp()
    {
        this.world = new World({ version2: this.version2 });
        this.app.stage.addChild( this.world );
    }

    gameEndAnim( pCallback )
    {
        this.world.boxContainer.endAnim( pCallback );
    }

    destroy()
    {
        this.eventHub.removeAllListeners();
    }
};



// WEBPACK FOOTER //
// ./src/app/game/Main.js